import { Icon } from '@iheartjane/reefer';
import type { IconComponentProps } from '@iheartjane/reefer';
import type { SVGProps } from 'react';

type StaticIconProps = Omit<IconComponentProps, 'color'>;

const Reviews = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="80" height="80" rx="40" fill="white" />
    <path
      d="M53.635 20.9085C53.8184 20.5369 54.3483 20.5369 54.5317 20.9085L56.6855 25.2726C56.7584 25.4201 56.8992 25.5224 57.062 25.5461L61.8781 26.2459C62.2882 26.3055 62.4519 26.8095 62.1552 27.0988L58.6702 30.4957C58.5524 30.6106 58.4986 30.7761 58.5264 30.9383L59.3491 35.7349C59.4192 36.1433 58.9905 36.4548 58.6237 36.262L54.316 33.9973C54.1704 33.9207 53.9964 33.9207 53.8507 33.9973L49.5431 36.262C49.1763 36.4548 48.7476 36.1433 48.8176 35.7349L49.6403 30.9383C49.6681 30.7761 49.6143 30.6106 49.4965 30.4957L46.0116 27.0988C45.7148 26.8095 45.8786 26.3055 46.2887 26.2459L51.1047 25.5461C51.2676 25.5224 51.4084 25.4201 51.4812 25.2726L53.635 20.9085Z"
      fill="#8E00E6"
      stroke="#8E00E6"
      strokeWidth="2"
    />
    <path
      d="M38.9438 19.8551C38.9936 19.7283 39.1731 19.7283 39.223 19.8551L40.3876 22.8176C40.409 22.8719 40.4599 22.9089 40.5182 22.9124L43.6956 23.1046C43.8316 23.1129 43.8871 23.2835 43.7818 23.3702L41.3242 25.3933C41.2792 25.4304 41.2597 25.4902 41.2744 25.5467L42.0735 28.628C42.1077 28.7599 41.9625 28.8654 41.8476 28.7921L39.1641 27.08C39.1148 27.0486 39.0519 27.0486 39.0027 27.08L36.3192 28.7921C36.2043 28.8654 36.0591 28.7599 36.0933 28.628L36.8924 25.5467C36.907 25.4902 36.8876 25.4304 36.8425 25.3933L34.3849 23.3702C34.2797 23.2835 34.3352 23.1129 34.4712 23.1046L37.6486 22.9124C37.7068 22.9089 37.7578 22.8719 37.7791 22.8176L38.9438 19.8551Z"
      fill="#8E00E6"
      stroke="#8E00E6"
      strokeWidth="2"
    />
    <path
      d="M62.203 38.5283V52.4853C62.203 52.8116 62.0724 53.1245 61.8399 53.3552C61.6074 53.5858 61.292 53.7154 60.9632 53.7154H46.6588C46.4344 53.716 46.2143 53.777 46.022 53.8919C45.8298 54.0068 45.6726 54.1713 45.5672 54.3679L41.8882 61.229C41.784 61.4236 41.629 61.5869 41.4394 61.7017C41.2498 61.8166 41.0325 61.8787 40.8104 61.8816C40.5883 61.8845 40.3695 61.8281 40.1769 61.7183C39.9842 61.6085 39.825 61.4493 39.7157 61.2574L35.758 54.3382C35.6499 54.1495 35.4934 53.9925 35.3045 53.8832C35.1155 53.7738 34.9007 53.7159 34.682 53.7154H19.5733C19.2444 53.7154 18.9291 53.5858 18.6965 53.3552C18.464 53.1245 18.3334 52.8116 18.3334 52.4853V28.7301C18.3334 28.4039 18.464 28.091 18.6965 27.8603C18.9291 27.6296 19.2444 27.5 19.5733 27.5H31.6485"
      stroke="#8E00E6"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <line
      x1="26.8334"
      y1="36.5"
      x2="43.3334"
      y2="36.5"
      stroke="#8E00E6"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="26.8334"
      y1="45"
      x2="52.8334"
      y2="45"
      stroke="#8E00E6"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ReviewsIcon = ({ size = 'xl', ...props }: StaticIconProps) => {
  return <Icon icon={Reviews} {...props} size={size} color={undefined} />;
};
